'use strict';

var dashboardGraphCtrl = ['dialog', 'Department', '$state',  '$uibModal', '$translate', 'Authentication','toast', function (dialog, Department, $state, $uibModal, $translate, Authentication,toast) {
    var _this = this;    
    this.$state = $state;
    this.currentUserIsViewer = Authentication.isAuthorized("viewer");
    this.currentUserIsSupervisor = Authentication.isAuthorized("supervisor");
    this.departmentId = $state.params.departmentId;
    
    this.deleteGraph = function (graph) {
        dialog.confirm({
            title: $translate.instant('DASHBOARD.DASH_GRAPH.DIAG_DEL.TITLE'),
            body: $translate.instant('DASHBOARD.DASH_GRAPH.DIAG_DEL.BODY'),
            accept: $translate.instant('DASHBOARD.DELETE'),
            cancel: $translate.instant('DASHBOARD.CANCEL'),
            size: 'sm'
        }).then(function () {
            Department.graphs.destroyById({
                id: $state.params.departmentId,
                fk: graph.id
            })
                .$promise.then(function () {
                    _this.graphs = _this.graphs.filter(function (old ) {
                        return old.id !== graph.id;
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        });
    };

}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            graph: '=',
            graphs: '='
        },
        controller: dashboardGraphCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-graphs/dashboardGraphsDirective.html'
    };
};